export const DashboardNavbar = {
  LogoDropdown: {},
  HeaderBreadcrumb: {
    fontSize: 'A',
    margin: '- -A - -',
    Button_username: null,
    Button_project: null
  },
  AddNewButton: {
    extends: ['CanvasButton', 'Button'],
    icon: 'plus',
    padding: 'Z Z2',
    gap: 'X2',
    text: '{{ editor.dashboard.newProject | polyglot }}',
    aspectRatio: 'none',
    Icon: {
      color: 'blue'
    },
    onClick: async (ev, el) => {
      await el.call('openRouterModal', '/settings', {
        key: '/onboarding'
      })
    }
  },
  DocsSearchHeader: {
    margin: '- auto'
  },
  ThemesInNavbar: {
    margin: '- A2 - -'
  },
  Avatar: {
    fontSize: 'X',
    onClick: async (ev, el) => {
      await el.call('openRouterModal', '/settings', {
        key: '/personal-account'
      })
    }
  },
  extends: 'Navbar',
  gap: 'A2',
  round: 'radiusPill',
  padding: 'W Z2',
  fontSize: 'Z1',
  userSelect: 'none',
  theme: 'common-box',
  position: 'sticky',
  top: 'X',
  left: 'X',
  right: 'X',
  zIndex: 9999999
}
